export default {
    header: {
        macrotrend: 'Macro-trend',
        megatrend: 'Mega-trend',
        author: 'Author',
        updatedAt: 'Last update at',
        tr: '#TR',
        if: '#IF',
        ip: '#IP',
        state: 'Active?',
        actions: 'Actions',
        copyOf: 'Copied TRENDONE trend'
    },
    filterOptions: {
        active: 'Active',
        inactive: 'Inactive'
    },
    search: 'Search',
    tooltip: {
        edit: 'Edit company macro trend',
        delete: 'Delete company macro trend'
    },
    delete: {
        question: 'Delete company macro trend &nbsp;<strong>"{title}"</strong>?',
        notice: 'Attention: This action <strong>cannot</strong> be undone!',
        links: {
            text: 'The company macro trend is "{title}" is linked to the following contents:',
            trendradars: 'Trend radar',
            innovationFields: 'Innovation field',
            innovationProjects: 'Innovation project',
            question: 'Are you sure you want to delete this trend? All links will be deleted.'
        },
        success: 'Company macro trend was successfully deleted!',
        action: {
            close: 'Close',
            delete: 'Delete'
        }
    }
}
